import { getHierarchy } from 'utils/hooks/useGetHierarchy';

export function getSubcategoryLabel(itemHierarchies, parentCategory) {
    if (!itemHierarchies?.length || !parentCategory) return null;
    const { hierarchy_hint: hierarchy } = getHierarchy(itemHierarchies);
    const { hierarchy_hint: parentHierarchy } = getHierarchy(
        parentCategory.hierarchies,
    );
    if (!hierarchy) return null;
    if (!parentHierarchy) return hierarchy.cat2;

    if (parentHierarchy.cat4) return null;
    if (parentHierarchy.cat3) return hierarchy.cat4;
    if (parentHierarchy.cat2) return hierarchy.cat3;
    return hierarchy.cat2;
}
